package com.ijoin.i18n

/**
 * Hindi strings implementation
 */
object HindiStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "मुझे क्लिक करें!"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "नमस्ते, $platformName!"
    override val language = "भाषा"
    override val english = "अंग्रेज़ी"
    override val russian = "रूसी"
    override val changeLanguage = "भाषा बदलें"
    override val ok = "ठीक है"
    override val cancel = "रद्द करें"
    override val save = "सहेजें"
    override val delete = "हटाएं"
    override val edit = "संपादित करें"
    override val close = "बंद करें"
    override val retry = "पुनः प्रयास करें"
    override val share = "साझा करें"
    override val unknownErrorMessage = "कुछ गलत हो गया। कृपया पुनः प्रयास करें।"
    override val missingEventDateError = "इवेंट की तारीख गायब है।"
    override val slotSelectionRequired = "कम से कम एक स्लॉट चुनें।"
    override val userContextMissingError = "वर्तमान उपयोगकर्ता की पहचान नहीं हो सकी।"
    override val cancelSlotsSelectionRequired = "रद्द करने के लिए कम से कम एक स्लॉट चुनें।"
    override val cancelDaySelectionRequired = "रद्द करने के लिए एक दिन चुनें।"
    override val restoreSlotsSelectionRequired = "पुनर्स्थापित करने के लिए कम से कम एक स्लॉट चुनें।"
    override val restoreDaySelectionRequired = "पुनर्स्थापित करने के लिए एक दिन चुनें।"
    override val cancelSlotsFailed = "चयनित स्लॉट रद्द नहीं हो सके।"
    override val cancelDayFailed = "चयनित दिन रद्द नहीं हो सका।"
    override val restoreSlotsFailed = "चयनित स्लॉट पुनर्स्थापित नहीं हो सके।"
    override val restoreDayFailed = "चयनित दिन पुनर्स्थापित नहीं हो सका।"
    override val cancelEventFailed = "इवेंट रद्द नहीं हो सका।"
    override val restoreEventFailed = "इवेंट पुनर्स्थापित नहीं हो सका।"
    override val selectedDateUnavailableError = "चयनित तारीख उपलब्ध नहीं है।"
    override val selectedDateInPastError = "चयनित तारीख बीत चुकी है।"
    override val notSelected = "चयनित नहीं"
    override fun atTime(time: String) = "$time बजे"
    override val enableNotificationsTitle = "अपडेट रहें"
    override val enableNotificationsBody = "नए इवेंट्स और चैट गतिविधि के बारे में अपडेट पाने के लिए ब्राउज़र नोटिफिकेशन सक्षम करें।"
    override val allowNotificationsAction = "नोटिफिकेशन की अनुमति दें"
    override val notNowAction = "अभी नहीं"
    override val searchPlaceholder = "इवेंट्स, आयोजकों, स्थानों को खोजें..."
    override val myTickets = "मेरी टिकटें"
    override val tapToViewTicket = "टिकट देखने के लिए टैप करें"
    override val favoriteEvents = "पसंदीदा"
    override val eventsYouSaved = "आपके सहेजे गए इवेंट्स"
    override val recommendedForYou = "आपके लिए अनुशंसित"
    override val curatedEvents = "आपकी रुचियों के आधार पर चुने गए इवेंट्स"
    override val recommendations = "अनुशंसाएं"
    override val upcomingEvents = "आगामी इवेंट्स"
    override val searchResults = "खोज परिणाम"
    override val noResults = "कोई परिणाम नहीं मिला"
    override val noAvailableEvents = "कोई उपलब्ध इवेंट नहीं"
    override val createEvent = "इवेंट बनाएं"
    override val menu = "मेन्यू"
    override val home = "होम"
    override val explore = "एक्सप्लोर"
    override val tickets = "टिकटें"
    override val profile = "प्रोफ़ाइल"
    override val upcomingPaidTicketsTitle = "आगामी भुगतान टिकटें"
    override val otherTicketsTitle = "अन्य टिकटें"
    override val offlineTicketsNotice = "सहेजी गई टिकटें दिखा रहे हैं। कुछ जानकारी पुरानी हो सकती है।"
    override val ticketsEmptyMessage = "आपके पास अभी कोई टिकट नहीं है।"
    override val ticketDetailsTitle = "टिकट विवरण"
    override val ticketNumberLabel = "टिकट नंबर"
    override val ticketStatusActive = "सक्रिय"
    override val ticketStatusCancelled = "रद्द"
    override val ticketStatusRefunded = "वापस"
    override val ticketStatusUsed = "उपयोग किया गया"
    override val ticketHolderLabel = "टिकट धारक"
    override val cancelTicketAction = "टिकट रद्द करें"
    override val ticketCancellationConfirmTitle = "टिकट रद्द करें?"
    override val ticketCancellationConfirmMessage = "इससे आपकी सीट वापस हो जाएगी और अन्य प्रतिभागी बुक कर सकेंगे।"
    override val ticketCancellationSuccess = "टिकट रद्द हो गई"
    override val ticketCancellationFailure = "टिकट रद्द नहीं हो सकी"
    override val ticketLoadError = "टिकट लोड नहीं हो सकी"
    override val refresh = "रिफ्रेश"
    override val settings = "सेटिंग्स"
    override val createEventTitle = "इवेंट बनाएं"
    override val eventTitle = "इवेंट शीर्षक"
    override val eventTitlePlaceholder = "इवेंट का नाम दर्ज करें"
    override val eventDescription = "विवरण"
    override val eventDescriptionPlaceholder = "अपने इवेंट का वर्णन करें..."
    override val aiGenerateDescription = "AI: विवरण उत्पन्न करें"
    override val aiFormatDescription = "AI: विवरण को संरचित और अंतिम रूप दें"
    override val addMedia = "फ़ोटो/वीडियो जोड़ें"
    override val mediaChooseFile = "फ़ाइल चुनें"
    override val location = "स्थान"
    override val onlineEvent = "ऑनलाइन इवेंट"
    override val onlineLink = "ऑनलाइन लिंक"
    override val onlineLinkPlaceholder = "https://example.com/meeting"
    override val onlineLinkNotice = "भुगतान के बाद लिंक उपलब्ध होगा"
    override val placeName = "स्थान का नाम"
    override val address = "पता"
    override val ticketPrice = "टिकट की कीमत"
    override val ticketPricePlaceholder = "25.00"
    override val dateAndTime = "दिनांक और समय"
    override val recurringEvent = "आवर्ती इवेंट"
    override val recurrenceType = "आवर्ती प्रकार"
    override val daysOfWeek = "सप्ताह के दिन"
    override val daysOfMonth = "महीने के दिन"
    override val selectDaysOfWeek = "सप्ताह के दिन चुनें"
    override val selectDaysOfMonth = "महीने के दिन चुनें"
    override val time = "समय (घं:मि)"
    override val hiddenInfo = "छिपी जानकारी"
    override val hiddenInfoDescription = "टिकट खरीदने के बाद उपयोगकर्ताओं को उपलब्ध होगा"
    override val hiddenInfoPlaceholder = "भुगतान के बाद ही दिखाई देने वाली जानकारी..."
    override val enableGroupChatLabel = "ग्रुप चैट बनाएं"
    override val enableGroupChatDescription = "जो भी बुक करता है या टिकट खरीदता है वह साझा चैट में शामिल होता है।"
    override val groupChatLabel = "ग्रुप चैट"
    override val groupChatSubtitle = "सभी प्रतिभागियों के लिए चैट"
    override val carpoolSettings = "कारपूल सेटिंग्स"
    override val enableCarpool = "कारपूल सक्षम करें"
    override val contactInfoSettings = "संपर्क जानकारी सेटिंग्स"
    override val requireContactInfo = "संपर्क जानकारी एकत्र करें"
    override val requireContactInfoDescription = "बुकिंग करते समय ग्राहकों से फ़ोन और अतिरिक्त जानकारी की आवश्यकता करें"
    override val freeCarpool = "मुफ्त कारपूल"
    override val carpoolPaymentPerPerson = "प्रति यात्री भुगतान"
    override fun carpoolPaymentLabel(symbol: String) = "प्रति व्यक्ति भुगतान ($symbol)"
    override val carpoolPaymentPlaceholder = "10.00"
    override val carpoolDescription = "उपयोगकर्ता बता सकते हैं कि उनके पास कार है और कितने यात्रियों को ले जा सकते हैं"
    override val carpoolPaymentHint = "यात्रियों को सवारी के लिए कितना भुगतान करना चाहिए यह सेट करें"
    override val selectDate = "तारीख चुनें"
    override val back = "वापस"
    override val create = "बनाएं"
    override val currency = "मुद्रा"
    override val selectCurrency = "मुद्रा चुनें"
    override val category = "श्रेणी"
    override val selectCategory = "श्रेणी चुनें"
    override val tags = "टैग्स"
    override val addTag = "टैग जोड़ें"
    override val maxCapacity = "अधिकतम क्षमता"
    override val maxCapacityPlaceholder = "50"
    override val duration = "अवधि"
    override val durationMinutes = "अवधि (मिनट)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks सप्ताह $remainingDays दिन"
                else "$weeks सप्ताह"
            }
            days > 0 -> {
                if (hours > 0) "$days दिन $hours घंटे"
                else "$days दिन"
            }
            hours > 0 -> {
                if (mins > 0) "$hours घंटे $mins मिनट"
                else "$hours घंटे"
            }
            else -> "$mins मिनट"
        }
    }
    override val locationCountry = "देश"
    override val selectOnMap = "मैप पर चुनें"
    override val locationSearchPlaceholder = "पता या स्थान का नाम दर्ज करें"
    override val onlineLinkHidden = "भुगतान के बाद ही लिंक दिखाई देगा"
    override val timeZone = "समय क्षेत्र"
    override fun timeZoneValue(timeZoneId: String) = "समय क्षेत्र: $timeZoneId"
    override val selectTimeZone = "समय क्षेत्र चुनें"
    override val localTimeZone = "स्थानीय समय क्षेत्र"
    override val mediaFilesAdded = "फ़ाइलें जोड़ी गईं"
    override val free = "मुफ्त"
    override val priceForFreeEvent = "0 - मुफ्त इवेंट के लिए"
    override val additionalOptions = "अतिरिक्त विकल्प"
    override val ageRestriction = "आयु प्रतिबंध"
    override val languageEvent = "इवेंट की भाषा"
    override val contactInfo = "संपर्क जानकारी"
    override val website = "वेबसाइट"
    override val phone = "फ़ोन"
    override val email = "ईमेल"
    override val comment = "टिप्पणी"
    override val phoneRequired = "फ़ोन आवश्यक है"
    override val city = "शहर"
    override val search = "खोजें"
    override val year = "वर्ष"
    override val month = "माह"
    override val day = "दिन"
    override fun weekdayShortName(index: Int) = listOf("सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि", "रवि")[index % 7]
    override fun weekdayName(index: Int) = listOf("सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार", "रविवार")[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "जनवरी", "फ़रवरी", "मार्च", "अप्रैल", "मई", "जून",
        "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = monthNameFull(month)
    override val createEventWizard = "इवेंट बनाएं"
    override val step = "चरण"
    override val of = "का"
    override val next = "अगला"
    override val previous = "पिछला"
    override val saveDraft = "ड्राफ्ट सहेजें"
    override val editEvent = "इवेंट संपादित करें"
    override val step1BasicInfo = "मूल जानकारी"
    override val step2Schedule = "समय-सारणी"
    override val scheduleTypeLabel = "समय-सारणी प्रकार"
    override val scheduleOneTimeDescription = "चुनी गई तारीख पर एकल इवेंट"
    override val scheduleWeeklyDescription = "चुने गए दिनों पर दोहराता है"
    override val scheduleSlotDescription = "बुक करने योग्य स्लॉट का कैलेंडर"
    override val scheduleOneTimeSetup = "एकल इवेंट सेटअप"
    override val schedulePreviewTitle = "पूर्वावलोकन"
    override fun schedulePreviewDate(date: String) = "तारीख: $date"
    override fun schedulePreviewTime(start: String, end: String) = "समय: $start - $end"
    override val step3Location = "स्थान"
    override val eventSetupTitle = "इवेंट सेटअप"
    override val eventTypeLabel = "इवेंट प्रकार"
    override val oneTimeEvent = "एकल इवेंट"
    override val eventSeries = "इवेंट सीरीज़"
    override val weekly = "साप्ताहिक"
    override val monthly = "मासिक"
    override val slotBooking = "स्लॉट बुकिंग"
    override val slotLabel = "स्लॉट"
    override val slotsLabel = "स्लॉट्स"
    override val selectDayOfWeek = "सप्ताह का दिन चुनें"
    override val selectDayOfMonth = "महीने का दिन चुनें"
    override val availableTimeRange = "उपलब्ध समय सीमा"
    override val startTime = "प्रारंभ समय"
    override val endTime = "समाप्ति समय"
    override val endDateLabel = "समाप्ति तारीख (वैकल्पिक)"
    override val invalidEndDate = "समाप्ति तारीख प्रारंभ तारीख के बाद या उसी दिन होनी चाहिए"
    override val invalidEndTime = "समाप्ति समय प्रारंभ समय के बाद होना चाहिए"
    override val eventDateMustBeFuture = "इवेंट की तारीख भविष्य में होनी चाहिए"
    override val eventTimeMustBeFuture = "इवेंट का समय वर्तमान समय के बाद होना चाहिए"
    override val slotSettings = "स्लॉट सेटिंग्स"
    override val minSlots = "न्यूनतम स्लॉट्स"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "अवधि (मिनट)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "प्रत्येक दिन के लिए उपलब्ध घंटे"
    override val driverCompensation = "ड्राइवर मुआवज़ा"
    override val fixedAmountPerPassenger = "प्रति यात्री निश्चित राशि"
    override val coordinateRide = "सवारी समन्वय करें"
    override val participantsWithCar = "कार वाले प्रतिभागी"
    override val needRide = "सवारी चाहिए"
    override val draft = "ड्राफ्ट"
    override val saved = "सहेजा गया"
    override val eventSaveErrorTitle = "इवेंट सहेज नहीं सका"
    override val eventSaveErrorMessage = "इवेंट सहेजते समय कुछ गलत हो गया। कृपया पुनः प्रयास करें।"
    override val deleteEventTitle = "इवेंट हटाएं?"
    override val deleteEventMessage = "यह क्रिया पूर्ववत नहीं की जा सकती। क्या आप जारी रखना चाहते हैं?"
    override val eventDeletedMessage = "इवेंट हटा दिया गया"
    override val organizerLabel = "आयोजक"
    override val online = "ऑनलाइन"
    override val offline = "ऑफ़लाइन"
    override val eventDetailsTitle = "इवेंट विवरण"
    override val addToFavorites = "पसंदीदा में जोड़ें"
    override val removeFromFavorites = "पसंदीदा से हटाएं"
    override val ticketTierStandard = "मानक"
    override fun ticketsAvailable(count: Int) = "$count टिकटें उपलब्ध"
    override val viewTicket = "टिकट देखें"
    override val bookingRequestFailed = "टिकट बुक नहीं हो सकी"
    override val contactSendFailed = "संपर्क जानकारी सबमिट नहीं हो सकी"
    override val unexpectedReservation = "मुफ्त इवेंट के लिए अप्रत्याशित आरक्षण"
    override val sampleReviewerName = "अन्ना पेट्रोवा"
    override val sampleReviewTimeAgo = "2 दिन पहले"
    override val selectVisitDate = "भ्रमण तारीख चुनें"
    override fun availableDaysLabel(days: String) = "उपलब्ध दिन: $days"
    override val previousMonth = "पिछला माह"
    override val nextMonth = "अगला माह"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "आपने चुना: $date" else "आपने चुना: $date $time बजे"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - छवि $index"
    override val dateTbd = "तय होना बाकी"
    override val recurringWeeklyDescription = "यह इवेंट चुने गए दिनों पर हर सप्ताह होता है।"
    override val recurringMonthlyDescription = "यह इवेंट चुने गए दिनों पर हर महीने होता है।"
    override val userCardTitle = "आयोजक प्रोफ़ाइल"
    override val followAction = "फ़ॉलो करें"
    override val followingAction = "फ़ॉलो कर रहे हैं"
    override val followersCountLabel = "फ़ॉलोअर्स"
    override val followingCountLabel = "फ़ॉलो कर रहे हैं"
    override val eventsCountLabel = "इवेंट्स"
    override val organizerEventsTitle = "आगामी इवेंट्स"
    override val archiveSectionTitle = "संग्रह"
    override val aboutOrganizerTitle = "आयोजक के बारे में"
    override val userEventsEmpty = "इस आयोजक के पास अभी कोई आगामी इवेंट नहीं है।"
    override val userArchiveEmpty = "कोई संग्रहीत इवेंट नहीं।"
    override val addShortcutTitle = "शॉर्टकट जोड़ें?"
    override fun addShortcutMessage(displayName: String) =
        "उनके इवेंट्स तक त्वरित पहुंच के लिए $displayName को अपनी होम स्क्रीन पर जोड़ें?"
    override val addShortcutConfirm = "शॉर्टकट जोड़ें"
    override val addShortcutDismiss = "अभी नहीं"
    override val dateLabel = "तारीख"
    override val participants = "प्रतिभागी"
    override val spotsLeft = "स्थान शेष"
    override val ticketQuantityLabel = "टिकटों की संख्या"
    override val increaseQuantity = "मात्रा बढ़ाएं"
    override val decreaseQuantity = "मात्रा घटाएं"
    override val costLabel = "भागीदारी की लागत"
    override val serviceFee = "सेवा शुल्क"
    override val totalAmount = "कुल"
    override fun serviceFeePercent(percent: Int) = "सेवा शुल्क ($percent%)"
    override val dressCode = "ड्रेस कोड"
    override val dressCodePlaceholder = "औपचारिक"
    override val description = "विवरण"
    override val reviews = "समीक्षाएं"
    override val allReviews = "सभी समीक्षाएं"
    override val contactOrganizer = "आयोजक से संपर्क करें"
    override val slotBookingsTitle = "स्लॉट बुकिंग्स"
    override val slotBookingsEmptyMessage = "अभी तक कोई स्लॉट बुक नहीं हुआ।"
    override val showAllBookings = "सभी"
    override val showToday = "आज"
    override val showThisMonth = "इस माह"
    override val showSelectedDate = "चयनित तारीख"
    override val noBookingsForSelectedDate = "इस तारीख के लिए कोई बुकिंग नहीं।"
    override val noTicketsForSelectedDate = "इस तारीख के लिए कोई टिकट नहीं।"
    override fun totalCount(count: Int) = "कुल: $count"
    override val cancelEventAction = "इवेंट रद्द करें"
    override val cancelEventDescription = "टिकट बिक्री बंद करें और इवेंट को सभी के लिए रद्द के रूप में चिह्नित करें।"
    override val organizerActionsTitle = "आयोजक उपकरण"
    override val eventAlreadyCancelledNotice = "इवेंट पहले से रद्द है।"
    override val eventCancelledTitle = "इवेंट रद्द"
    override val eventCancelledSubtitle = "आयोजक ने इस इवेंट को रद्द कर दिया। बुकिंग अब उपलब्ध नहीं है।"
    override val cancellationReasonLabel = "रद्द करने का कारण"
    override val cancellationReasonPlaceholder = "रद्द करने का कारण बताएं"
    override val cancellationReasonRequired = "कृपया एक संक्षिप्त कारण दें।"
    override val cancelSelectedSlotsAction = "चयनित स्लॉट रद्द करें"
    override val cancelSelectedSlotsDescription = "प्रतिभागी अब चयनित स्लॉट आरक्षित नहीं कर पाएंगे।"
    override val cancelSlotDayAction = "चयनित दिन रद्द करें"
    override val cancelSlotDayDescription = "चयनित दिन के सभी स्लॉट अवरुद्ध हो जाएंगे।"
    override val selectedSlotsLabel = "चयनित स्लॉट्स"
    override val selectedDayLabel = "चयनित दिन"
    override val restoreEventAction = "इवेंट पुनर्स्थापित करें"
    override val restoreEventDescription = "रद्दीकरण के बाद इवेंट को फिर से खोलें।"
    override val restoreSelectedSlotsAction = "चयनित स्लॉट पुनर्स्थापित करें"
    override val restoreSelectedSlotsDescription = "प्रतिभागियों को चयनित स्लॉट फिर से बुक करने दें।"
    override val restoreSlotDayAction = "चयनित दिन पुनर्स्थापित करें"
    override val restoreSlotDayDescription = "चयनित दिन के सभी स्लॉट फिर से खोलें।"
    override val bookingStatusPending = "लंबित"
    override val bookingStatusConfirmed = "पुष्टि"
    override val bookingStatusCancelled = "रद्द"
    override val bookingStatusCompleted = "बुक किया गया"
    override val bookingStatusNoShow = "अनुपस्थित"
    override val viewDetails = "विवरण देखें"
    override val hideDetails = "विवरण छिपाएं"
    override val openChat = "चैट खोलें"
    override val clientNotesLabel = "ग्राहक टिप्पणी"
    override val bookingDetailsTitle = "बुकिंग विवरण"
    override val slotBookedByLabel = "बुक किया गया"
    override val slotAvailableLabel = "उपलब्ध"
    override val statusLabel = "स्थिति"
    override val connectTitle = "डायरेक्ट भुगतान"
    override val connectStatusActive = "सक्रिय"
    override val connectStatusPending = "लंबित"
    override val connectStatusPlatform = "प्लेटफ़ॉर्म"
    override val connectStatusUnderReview = "समीक्षा में"
    override val connectStatusSetupNeeded = "सेटअप आवश्यक"
    override val connectEnableDirectAction = "डायरेक्ट भुगतान सक्षम करें"
    override val connectContinueOnboarding = "सेटअप जारी रखें"
    override val connectOpenDashboard = "Stripe डैशबोर्ड खोलें"
    override val connectSwitchToPlatform = "प्लेटफ़ॉर्म भुगतान पर स्विच करें"
    override val connectPlatformFeeLabel = "प्लेटफ़ॉर्म शुल्क"
    override val connectDirectPaymentsEnabled = "डायरेक्ट भुगतान सक्षम"
    override val connectSwitchedToPlatform = "प्लेटफ़ॉर्म भुगतान पर स्विच किया गया"
    override val connectOnboardingDescription = "सीधे भुगतान प्राप्त करने के लिए अपना Stripe खाता सेट करें"
    override val connectActiveDescription = "भुगतान सीधे आपके Stripe खाते में जाते हैं"
    override val connectPlatformDescription = "भुगतान प्लेटफ़ॉर्म के माध्यम से प्रोसेस होते हैं"
    override val connectUnderReviewDescription = "आपका खाता Stripe द्वारा समीक्षा में है"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "बिलिंग"
    override val currentBalanceLabel = "वर्तमान शेष"
    override val openBillingAction = "बिलिंग और भुगतान"
    override val withdrawFundsAction = "धन निकालें"
    override val pendingPayoutsLabel = "लंबित भुगतान"
    override val withdrawnTotalLabel = "निकाला गया"
    override val billingFilterWeek = "7 दिन"
    override val billingFilterMonth = "30 दिन"
    override val billingFilterQuarter = "90 दिन"
    override val grossSalesLabel = "कुल बिक्री"
    override val feesLabel = "शुल्क"
    override val netRevenueLabel = "शुद्ध राजस्व"
    override val payoutRequestsTitle = "निकासी अनुरोध"
    override val payoutRequestsEmpty = "अभी तक कोई निकासी अनुरोध नहीं"
    override val payoutStatusPending = "लंबित"
    override val payoutStatusProcessing = "प्रोसेसिंग"
    override val payoutStatusPaid = "भुगतान किया गया"
    override val payoutStatusRejected = "अस्वीकृत"
    override val requisitesTitle = "भुगतान विवरण"
    override val requisitesAccountLabel = "खाता संख्या"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "बैंक"
    override val soldTicketsTitle = "बेची गई टिकटें"
    override val soldTicketsEmpty = "इस अवधि में कोई टिकट बिक्री नहीं"
    override val withdrawConfirmTitle = "धन निकालें?"
    override fun withdrawConfirmMessage(amount: String) = "आप $amount के भुगतान का अनुरोध करने वाले हैं।"
    override val billingWithdrawSuccess = "निकासी अनुरोध सबमिट किया गया"
    override val billingWithdrawFailed = "निकासी अनुरोध सबमिट नहीं हो सका"
    override val billingWithdrawUnavailable = "निकासी के लिए कोई शेष उपलब्ध नहीं है"
    override val payoutMethodEtransfer = "eTransfer (कनाडा)"
    override val payoutMethodWise = "Wise ट्रांसफर"
    override val payoutDetailsTitle = "भुगतान विवरण"
    override val payoutEmailLabel = "प्राप्तकर्ता ईमेल"
    override val payoutWiseNameLabel = "खाताधारक का नाम"
    override val payoutWiseAccountLabel = "खाता संख्या / IBAN"
    override val payoutWiseBankLabel = "बैंक का नाम या SWIFT"
    override val payoutWiseRoutingLabel = "रूटिंग नंबर"
    override val payoutWiseAccountTypeLabel = "खाता प्रकार"
    override val payoutAccountTypeChecking = "चेकिंग"
    override val payoutAccountTypeSavings = "बचत"
    override val payoutNoteLabel = "निकासी नोट (वैकल्पिक)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) = "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) = "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "जन"; 2 -> "फर"; 3 -> "मार्च"; 4 -> "अप्रै"; 5 -> "मई"; 6 -> "जून"
        7 -> "जुला"; 8 -> "अग"; 9 -> "सित"; 10 -> "अक्टू"; 11 -> "नव"; 12 -> "दिस"
        else -> ""
    }
    override val accountDetails = "खाता विवरण"
    override val interfaceLanguage = "इंटरफ़ेस भाषा"
    override val profileSavedMessage = "प्रोफ़ाइल अपडेट हुई"
    override val profileLogoutDescription = "इस डिवाइस पर iJoin से साइन आउट करें।"
    override val profileLoadError = "प्रोफ़ाइल लोड नहीं हो सकी"
    override val logoutError = "लॉग आउट विफल। कृपया पुनः प्रयास करें।"
    override val messagesTitle = "संदेश"
    override val emptyChatList = "अभी कोई बातचीत नहीं"
    override val emptyMessages = "अभी कोई संदेश नहीं। बातचीत शुरू करें!"
    override val typeMessage = "संदेश..."
    override val send = "भेजें"
    override val chatSearchPlaceholder = "नाम से उपयोगकर्ता खोजें"
    override val chatSearchNoResults = "कोई उपयोगकर्ता नहीं मिला"
    override val chatLoadError = "चैट संदेश लोड नहीं हो सके"
    override val chatSendError = "संदेश भेज नहीं सका"
    override val chatOpenError = "चैट खोल नहीं सका"
    override val chatStartError = "चैट शुरू नहीं हो सका"
    override val chatSearchError = "अभी उपयोगकर्ता खोज नहीं सके"
    override val paymentTitle = "आरक्षण भुगतान"
    override val paymentSubtitle = "अपनी बुकिंग के लिए भुगतान पूरा करें"
    override val paymentDescription = "भुगतान सफल होने पर, आपका आरक्षण स्वचालित रूप से अपडेट हो जाएगा।"
    override val paymentPreparing = "Stripe चेकआउट तैयार कर रहे हैं..."
    override val paymentFetchingTickets = "आपकी टिकटें प्राप्त कर रहे हैं..."
    override val paymentCompletedMessage = "भुगतान पुष्टि हो गई। अगर टिकटें स्वचालित रूप से नहीं दिखीं, तो नीचे की सूची रिफ्रेश करें।"
    override val paymentStripePopupHint = "Stripe एक पॉप-अप विंडो में खुलता है। अगर कुछ नहीं दिखा या आपने इसे बंद कर दिया, तो \"भुगतान पुनः प्रारंभ करें\" टैप करें।"
    override val paymentRetryButton = "भुगतान पुनः प्रारंभ करें"
    override val paymentRetryTicketsButton = "टिकटें फिर से प्राप्त करें"
    override val paymentStartFailed = "भुगतान शुरू करने में विफल"
    override val paymentTicketContextMissing = "टिकट जारी करने के लिए बुकिंग निर्धारित नहीं हो सकी"
    override val paymentTicketsNotFound = "टिकटें नहीं मिलीं"
    override val paymentTicketsFetchFailed = "टिकटें प्राप्त करने में असमर्थ"
    override val errorUserNotAuthenticated = "जारी रखने के लिए कृपया साइन इन करें।"
    override val errorAccessDenied = "आपके पास यह क्रिया करने की अनुमति नहीं है।"
    override val errorForbiddenFollowingList = "आप केवल अपनी फ़ॉलोइंग सूची देख सकते हैं।"
    override val errorDataUrlRequired = "छवि डेटा (dataUrl) आवश्यक है।"
    override val errorMediaStoreFailed = "मीडिया स्टोर करने में विफल। कृपया पुनः प्रयास करें।"
    override val errorAmountMustBePositive = "राशि शून्य से अधिक होनी चाहिए।"
    override val errorAmountExceedsBalance = "अनुरोधित राशि उपलब्ध शेष से अधिक है।"
    override val errorPayoutEmailRequired = "eTransfer भुगतान के लिए ईमेल आवश्यक है।"
    override val errorPayoutWiseInfoRequired = "Wise भुगतान के लिए पूरा नाम, रूटिंग नंबर और खाता संख्या आवश्यक है।"
    override val errorPayoutAccountType = "असमर्थित खाता प्रकार। चेकिंग या बचत का उपयोग करें।"
    override val errorUnsupportedPayoutMethod = "असमर्थित भुगतान विधि।"
    override val errorEventNotCancelled = "इवेंट रद्द नहीं है।"
    override val errorChatWithSelf = "आप अपने साथ चैट नहीं कर सकते।"
    override val errorChatMessageEmpty = "संदेश खाली नहीं हो सकता।"
    override val errorEventOrganizerRequired = "इवेंट ID और आयोजक आवश्यक हैं।"
    override val errorEventUnavailable = "इवेंट अब उपलब्ध नहीं है।"
    override val errorEventFinished = "इवेंट पहले ही समाप्त हो चुका है।"
    override val errorOrganizerNotProvider = "आयोजक सेवा प्रदाता नहीं है।"
    override val errorServiceProviderInactive = "सेवा प्रदाता सक्रिय नहीं है।"
    override val errorSlotsNotFound = "कुछ समय स्लॉट नहीं मिले।"
    override val errorSlotsMustSameEvent = "सभी समय स्लॉट एक ही इवेंट के होने चाहिए।"
    override val errorSlotsMustSameOrganizer = "सभी समय स्लॉट इवेंट के आयोजक के होने चाहिए।"
    override val errorSlotsUnavailable = "एक या अधिक समय स्लॉट उपलब्ध नहीं हैं।"
    override val errorSlotsInPast = "बीते हुए समय स्लॉट बुक नहीं किए जा सकते।"
    override val errorSlotsMustBeConsecutive = "समय स्लॉट क्रमिक होने चाहिए।"
    override val errorEventIdRequired = "इवेंट ID आवश्यक है।"
    override val errorQuantityAtLeastOne = "मात्रा कम से कम 1 होनी चाहिए।"
    override val errorPaidReservationRequired = "इस इवेंट के लिए भुगतान आरक्षण आवश्यक है।"
    override val errorEventOrganizerInvalid = "इवेंट आयोजक मान्य नहीं है।"
    override val errorEventOrganizerMissing = "इवेंट आयोजक सेट नहीं है।"
    override val errorOrganizerCannotAccept = "आयोजक बुकिंग स्वीकार करने में असमर्थ है।"
    override val errorOccurrenceRequired = "घटना तारीख आवश्यक है।"
    override val errorOccurrencePassed = "चयनित घटना पहले ही बीत चुकी है।"
    override val errorTicketsNotEnough = "इस इवेंट के लिए पर्याप्त टिकटें उपलब्ध नहीं हैं।"
    override val errorBookingOtherUser = "बुकिंग किसी अन्य उपयोगकर्ता की है।"
    override val errorBookingNotAwaitingPayment = "बुकिंग भुगतान की प्रतीक्षा में नहीं है।"
    override val errorBookingCancelled = "बुकिंग पहले से रद्द है।"
    override val errorBookingNotActive = "बुकिंग अब सक्रिय नहीं है।"
    override val errorBookingIssuedTickets = "बुकिंग में पहले से टिकटें जारी हैं।"
    override val errorEventRequiresPaymentFlow = "इस इवेंट के लिए भुगतान आवश्यक है। बुकिंग पूरी करने के लिए चेकआउट पूरा करें।"
    override val errorReservationQuantityExceeded = "अनुरोधित मात्रा आरक्षण से अधिक है।"
    override val errorTicketAlreadyValidated = "टिकट पहले से सत्यापित है।"
    override val errorTicketInactive = "टिकट सक्रिय नहीं है।"
    override val errorTicketAlreadyCancelled = "टिकट पहले से रद्द है।"
    override val errorTicketUsed = "उपयोग की गई टिकटें रद्द नहीं की जा सकतीं।"
    override val errorOccurrencesRequired = "घटनाएं आवश्यक हैं।"
    override val errorRequestRequired = "अनुरोध पेलोड आवश्यक है।"
    override val errorBookingEventMismatch = "बुकिंग प्रदान किए गए इवेंट से संबंधित नहीं है।"
    override val errorBookingProcessed = "बुकिंग पहले से संसाधित है।"
    override val errorOverrideAmountAdminOnly = "ओवरराइड राशि केवल प्रशासकों के लिए अनुमत है।"
    override val errorOverrideAmountPositive = "ओवरराइड राशि सकारात्मक होनी चाहिए।"
    override val errorUnableDetermineTicketPrice = "टिकट की कीमत निर्धारित करने में असमर्थ।"
    override val errorEmailAlreadyRegistered = "ईमेल पहले से पंजीकृत है।"
    override val errorInvalidCredentials = "अमान्य ईमेल या पासवर्ड।"
    override val errorAccountInactive = "खाता निष्क्रिय है।"
    override val errorInvalidRefreshToken = "अमान्य रिफ्रेश टोकन।"
    override val errorAvatarDataUrlRequired = "अवतार डेटा data URL के रूप में प्रदान किया जाना चाहिए।"
    override val errorAvatarMustBeImage = "अवतार एक छवि होनी चाहिए।"
    override val errorAvatarInvalidDataUrl = "अवतार data URL अमान्य है।"
    override val errorStripeSignatureInvalid = "अमान्य Stripe हस्ताक्षर।"
    override val errorMediaUnsupportedFormat = "असमर्थित छवि प्रारूप।"
    override val errorReservationExpired = "आरक्षण समाप्त हो गया। कृपया नई बुकिंग करें।"
    override val login = "लॉगिन"
    override val register = "पंजीकरण"
    override val continueWithGoogle = "Google से जारी रखें"
    override val continueWithApple = "Apple से जारी रखें"
    override val logout = "लॉग आउट"
    override val password = "पासवर्ड"
    override val username = "उपयोगकर्ता नाम"
    override val firstName = "पहला नाम"
    override val lastName = "उपनाम"
    override val confirmPassword = "पासवर्ड की पुष्टि करें"
    override val alreadyHaveAccount = "पहले से खाता है?"
    override val dontHaveAccount = "खाता नहीं है?"
    override val loginHere = "यहां लॉगिन करें"
    override val registerHere = "यहां पंजीकरण करें"
    override val welcomeBack = "वापसी पर स्वागत है!"
    override val createAccount = "खाता बनाएं"
    override val loginError = "लॉगिन विफल। कृपया अपने क्रेडेंशियल जांचें।"
    override val registerError = "पंजीकरण विफल। कृपया पुनः प्रयास करें।"
    override val passwordsDontMatch = "पासवर्ड मेल नहीं खाते"
    override val fillAllFields = "कृपया सभी आवश्यक फ़ील्ड भरें"
    override val invalidEmail = "कृपया एक मान्य ईमेल पता दर्ज करें"
    override val forgotPassword = "पासवर्ड भूल गए?"
    override val passwordResetTitle = "पासवर्ड रीसेट करें"
    override val passwordResetDescription = "रीसेट निर्देश प्राप्त करने के लिए अपना ईमेल पता दर्ज करें।"
    override val passwordResetSetNewPassword = "नया पासवर्ड सेट करें"
    override val sendResetLink = "रीसेट लिंक भेजें"
    override fun passwordResetEmailSent(email: String) = "अगर $email के लिए खाता मौजूद है, तो हमने रीसेट लिंक भेज दिया है।"
    override val passwordResetTokenLabel = "रीसेट टोकन"
    override val passwordResetTokenDescription = "अपने ईमेल से कोड पेस्ट करें या इस डिवाइस पर लिंक खोलें।"
    override val newPassword = "नया पासवर्ड"
    override val resetPasswordAction = "पासवर्ड अपडेट करें"
    override val passwordResetSuccess = "पासवर्ड अपडेट हो गया! आप नए पासवर्ड से साइन इन कर सकते हैं।"
    override val profileDeletedMessage = "खाता हटा दिया गया"
    override val deleteAccountTitle = "खाता हटाएं"
    override val deleteAccountDescription = "यह आपके खाते को निष्क्रिय कर देगा, व्यक्तिगत डेटा को गुमनाम करेगा और आपके इवेंट्स को खोज से हटा देगा।"
    override val deleteAccountAction = "खाता हटाएं"
    override val deleteAccountConfirmMessage = "क्या आप सुनिश्चित हैं? खाता हटाने से पहले कृपया payout अनुरोध के माध्यम से शेष राशि निकाल लें।"
    override val aiConsentSectionTitle = "AI डेटा प्रोसेसिंग"
    override val aiConsentEnabled = "आपने ट्रांसक्रिप्शन और विवरण जनरेशन जैसी वैकल्पिक सुविधाओं के लिए AI सेवाओं (OpenAI, Google) के साथ डेटा साझा करने की सहमति दी है।"
    override val aiConsentDisabled = "AI डेटा प्रोसेसिंग की सहमति सक्रिय नहीं है। AI सुविधाएँ उपलब्ध नहीं हैं।"
    override val aiConsentWithdrawButton = "सहमति वापस लें"
    override val aiConsentEnableButton = "AI सुविधाएँ सक्षम करें"
    override val aiConsentWithdrawConfirmTitle = "AI सहमति वापस लें?"
    override val aiConsentWithdrawConfirmMessage = "AI सुविधाएँ (ट्रांसक्रिप्शन, विवरण जनरेशन, लैंडिंग पेज) उपलब्ध नहीं रहेंगी। आप उन्हें किसी भी समय फिर से सक्षम कर सकते हैं।"
    override val aiConsentWithdrawnSuccess = "AI डेटा प्रोसेसिंग की सहमति वापस ले ली गई"
    override val aiConsentEnabledSuccess = "AI डेटा प्रोसेसिंग की सहमति दी गई"
    override val errorAccountDeleted = "खाता हटा दिया गया है।"
    override val errorAccountBalanceNotZero = "खाता हटाने से पहले कृपया शेष राशि निकाल लें।"

    override val backToLogin = "लॉगिन पर वापस जाएं"
    override val invalidPhone = "कृपया एक मान्य फ़ोन नंबर दर्ज करें"
    override val provideAnyContact = "फ़ोन या ईमेल दर्ज करें"
    override val checkContacts = "कृपया संपर्क प्रारूप जांचें"
    override val contactSubmitting = "सहेज रहे हैं..."
    override val contactSubmitted = "अनुरोध भेजा गया"
    override val book = "बुक करें"
    override val bookFree = "मुफ्त बुक करें"
    override val bookingSuccess = "सफलतापूर्वक बुक किया गया!"
    override val bookingFailed = "बुकिंग विफल"
    override fun bookForPrice(price: String) = "$price में बुक करें"
    override val prev = "पिछला"
    override val showAll = "सभी दिखाएं"
    override val collapse = "संक्षिप्त करें"
    override val missingTitle = "इवेंट शीर्षक दर्ज करें"
    override val missingDescription = "इवेंट विवरण दर्ज करें"
    override val missingScheduleType = "समय-सारणी प्रकार चुनें"
    override val missingDate = "इवेंट तारीख चुनें"
    override val missingTime = "इवेंट समय चुनें"
    override val missingWeeklyDays = "एक या अधिक दिन चुनें"
    override val missingWeeklyTime = "साप्ताहिक इवेंट के लिए समय चुनें"
    override val missingSlotDays = "स्लॉट के दिन चुनें"
    override val missingSlotStart = "स्लॉट प्रारंभ समय चुनें"
    override val missingSlotEnd = "स्लॉट समाप्ति समय चुनें"
    override val missingLocation = "कृपया इवेंट स्थान निर्दिष्ट करें"
    override val optional = "वैकल्पिक"
    override val bookingsTitle = "बुकिंग्स"
    override val unconfirmedRequestsTitle = "अपुष्ट अनुरोध"
    override val detailsButton = "विवरण"
    override val hideDetailsBooking = "छिपाएं"
    override val noBookings = "अभी कोई बुकिंग नहीं"
    override val noUnconfirmedRequests = "कोई अपुष्ट अनुरोध नहीं"
    override val ticketInfoLabel = "टिकट"
    override val contactInfoLabel = "संपर्क जानकारी"
    override val paymentInfoLabel = "भुगतान"
    override val loadingPayment = "लोड हो रहा है..."
    override val clientLabel = "ग्राहक"
    override val paymentAmount = "राशि"
    override val paymentStatus = "स्थिति"
    override val paymentDate = "तारीख"
    override val appStoreBannerTitle = "ऐप प्राप्त करें"
    override val appStoreBannerMessage = "सर्वोत्तम अनुभव के लिए हमारा ऐप डाउनलोड करें"
    override val downloadOnAppStore = "App Store पर डाउनलोड करें"
    override val getItOnGooglePlay = "Google Play पर प्राप्त करें"
    override val downloadAppLinks = "हमारा ऐप डाउनलोड करें"
    override val updateAvailable = "अपडेट उपलब्ध"
    override val updateRequired = "अपडेट आवश्यक"
    override val updateAvailableMessage = "iJoin का नया संस्करण उपलब्ध है। नवीनतम सुविधाओं और सुधारों के लिए अभी अपडेट करें।"
    override val updateRequiredMessage = "ऐप का उपयोग जारी रखने के लिए कृपया iJoin अपडेट करें। यह संस्करण अब समर्थित नहीं है।"
    override val updateNow = "अभी अपडेट करें"
    override val updateLater = "बाद में"
    override val newVersion = "नया संस्करण"
    override val currentVersion = "वर्तमान संस्करण"
    override val whatsNew = "नया क्या है"
    override val landingModeClassic = "क्लासिक"
    override val landingModeAi = "AI लैंडिंग पेज"
    override val landingModeTitle = "लैंडिंग पेज प्रकार"
    override val landingDescriptionLabel = "लैंडिंग विवरण"
    override val landingDescriptionPlaceholder = "AI को सुंदर लैंडिंग पेज बनाने के लिए अपने इवेंट का वर्णन करें..."
    override val recordVoice = "आवाज़ रिकॉर्ड करें"
    override val stopRecording = "रिकॉर्डिंग बंद करें"
    override val transcribing = "ट्रांसक्राइब हो रहा है..."
    override val recordingTooShort = "रिकॉर्डिंग बहुत छोटी है (न्यूनतम 3 सेकंड)"
    override val recordingTooLong = "रिकॉर्डिंग बहुत लंबी है (अधिकतम 5 मिनट)"
    override val microphoneAccessDenied = "माइक्रोफ़ोन एक्सेस अस्वीकृत"
    override fun recordingDuration(seconds: Int) = "${seconds}से"
    override val enableLandingPageLabel = "लैंडिंग पेज का उपयोग करें"
    override val enableLandingPageDescription = ""
    override val termsOfService = "सेवा की शर्तें"
    override val privacyPolicy = "गोपनीयता नीति"
    override val refundPolicy = "वापसी और रद्दीकरण नीति"
    override val organizerTerms = "आयोजक शर्तें"
    override val aiDataConsent = "AI डेटा प्रोसेसिंग सहमति"
    override val aiConsentTitle = "AI सुविधाएँ तृतीय-पक्ष सेवाओं का उपयोग करती हैं"
    override val aiConsentDescription = "इस ऐप की कुछ सुविधाएँ OpenAI और Google द्वारा प्रदान की गई कृत्रिम बुद्धिमत्ता सेवाओं का उपयोग करती हैं। इन सुविधाओं का उपयोग करते समय, आपके द्वारा प्रदान की गई कुछ सामग्री प्रोसेसिंग के लिए इन सेवाओं को भेजी जाती है।"
    override val aiConsentDataSent = "भेजे जा सकने वाले डेटा:"
    override val aiConsentDataSentAudio = "ऑडियो रिकॉर्डिंग (ट्रांसक्रिप्शन के लिए)"
    override val aiConsentDataSentDescription = "इवेंट विवरण (टेक्स्ट सुधार के लिए)"
    override val aiConsentDataSentLanding = "लैंडिंग पेज विवरण (सामग्री निर्माण के लिए)"
    override val aiConsentProviders = "डेटा OpenAI (OpenAI, L.L.C.) और Google (Google LLC) द्वारा प्रोसेस किया जाता है। आपका व्यक्तिगत डेटा (नाम, ईमेल) तब तक नहीं भेजा जाता जब तक वह आपके द्वारा सबमिट की गई सामग्री का हिस्सा न हो। पूर्ण विवरण के लिए दस्तावेज़ देखें।"
    override val aiConsentOptional = "AI सुविधाएँ वैकल्पिक हैं। आप इनके बिना ऐप का उपयोग कर सकते हैं।"
    override val aiConsentAccept = "मैं सहमत हूं"
    override val aiConsentDecline = "अभी नहीं"
    override val iAgreeToThe = "मैं निम्नलिखित से सहमत हूं:"
    override val iAgreeToTerms = "मैं सेवा की शर्तों, गोपनीयता नीति और वापसी नीति से सहमत हूं"
    override val iAgreeToOrganizerTerms = "मैं आयोजक शर्तों से सहमत हूं"
    override val pleaseAcceptTerms = "जारी रखने के लिए कृपया शर्तें स्वीकार करें"
    override val pleaseAcceptOrganizerTerms = "इवेंट प्रकाशित करने के लिए कृपया आयोजक शर्तें स्वीकार करें"
    override val viewDocument = "देखें"
    override val legalDocumentLoading = "दस्तावेज़ लोड हो रहा है..."
    override val legalDocumentLoadError = "दस्तावेज़ लोड करने में विफल"
    override val newUserGoogleNote = "अगर आप नए हैं, तो Google से साइन इन करने से पहले कृपया शर्तें स्वीकार करें:"
    override val legalDocumentsUpdated = "शर्तें अपडेट हुईं"
    override val legalDocumentsUpdatedDescription = "हमने अपनी शर्तें अपडेट की हैं। ऐप का उपयोग जारी रखने के लिए कृपया अपडेट किए गए दस्तावेज़ों की समीक्षा करें और स्वीकार करें।"
    override val iAcceptUpdatedTerms = "मैं अपडेट की गई शर्तें स्वीकार करता हूं"
    override val continueButton = "जारी रखें"
    override val deleteEventFailed = "इवेंट को हटाया नहीं जा सका।"
    override val mediaDesktopLabel = "डेस्कटॉप के लिए (वाइड)"
    override val mediaMobileLabel = "मोबाइल के लिए (स्क्वायर)"
    override val slotLoadFailed = "स्लॉट लोड नहीं हो सके"
    override val slotBookingFailed = "स्लॉट बुक नहीं हो सके"
    override val ticketIssuanceFailed = "टिकट जारी नहीं हो सके"
    override val unpublishedBookingNotice = "यह इवेंट प्रकाशित होने के बाद बुकिंग उपलब्ध होगी।"
    override val paymentStripeOverlayTitle = "Stripe भुगतान"
    override val paymentStripeOverlayDescription = "बुकिंग पूरी करने के लिए अपने कार्ड का विवरण दर्ज करें।"
    override val paymentStripeOverlayPayButton = "अभी भुगतान करें"
    override val paymentStripeOverlayPayButtonLoading = "प्रोसेस हो रहा है..."
    override val paymentStripeOverlayCancelButton = "रद्द करें"
    override val paymentStripeOverlayOpenError = "Stripe चेकआउट खोलने में असमर्थ।"
    override val paymentStripeOverlayCancelMessage = "भुगतान रद्द किया गया"
    override val paymentStripeOverlayInitError = "Stripe प्रारंभ नहीं हो सका।"
    override val paymentStripeOverlayPaymentFailed = "भुगतान विफल"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "अप्रत्याशित स्थिति: "
    override val paymentStripeOverlayProcessingFailed = "भुगतान प्रोसेस करने में विफल"
    override val appStoreUnavailableMessage = "क्षमा करें, ऐप स्टोर में प्रकाशित किया जा रहा है और जल्द ही उपलब्ध होगा।"

}
